<template>
  <div class="caracteristica-block w-full md:w-6 lg:w-4">
    <div :class="'inner-box wow ' + (itemIndex % 3  == 0 || itemIndex % 3 == 1 ? 'fade-in-left' : 'fade-in-right')">
      <div class="icon-box"><i :class="'icon ' + item.icone"></i></div>
      <div class="descricao" v-html="item.descricao"></div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  props: {
    item: Object,
    itemIndex: Number,
  },
  computed: {},
  watch: {},
  methods: {},
  created() {},
  mounted() {},
  unmounted() {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.caracteristica-block {
  position: relative;
  padding: 0 11px;
  margin-bottom: 40px;
}
.caracteristica-block .inner-box {
  height: 100%;
  padding: 60px 40px;
  background-color: #ffffff;
  text-align: center;
  outline: 1px solid transparent;
  outline-offset: -1px;
  transition: all 500ms ease;
  box-shadow: 0 15px 46px rgba(0, 0, 0, .1);
}
.caracteristica-block .icon-box {
  position: relative;
  top: 0px;
  height: 80px;
  width: 80px;
  line-height: 80px;
  font-size: 70px;
  color: var(--ibase-color);
  margin: 0 auto 30px;
  transition: all 500ms ease;
}
.caracteristica-block .descricao {
  display: block;
  font-size: 20px;
  font-weight: 500;
  line-height: 1.2em;
  color: #202020;
  margin-bottom: 25px;
}
.caracteristica-block .inner-box:hover {
  outline-color: var(--ibase-color);
  outline-offset: -6px;
}
.caracteristica-block .inner-box:hover .icon-box {
  transform: scale(1.1) translateY(-4px);
}
</style>
